import { makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import AddQADetails from './AddQADetails';

export const useStyles = makeStyles((theme) => ({
  multipleLogo: {
    // padding: '0.3rem',
    height: 'inherit',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  addIcon: {
    border: '1px solid black',
    borderRadius: '4px',
    padding: '2px',
    cursor: 'pointer',
    marginLeft: '0.5rem',
    transition: 'all 0.3s ease',
    color: 'black',

    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
    },
  },
}));

const QADetails = ({ POLineRecordDetails, row, status, saveRecord }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const openViewScreen = () => {
    setOpen(true);
  };
  const closeViewScreen = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <AddIcon
        fontSize='medium'
        className={classes.addIcon}
        onClick={openViewScreen}
      />

      {open === true && (
        <AddQADetails
          openDialog={open}
          closeViewScreen={closeViewScreen}
          POLineRecordDetails={POLineRecordDetails}
          row={row}
          status={status}
          saveRecord={saveRecord}
        />
      )}
    </React.Fragment>
  );
};

export default QADetails;
